// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-user-container {
    background: #111111;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.create-user-form {
    display: flex;
    gap: 3rem;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 350px;
    margin-top: 30px;
}

.row {
    flex: 1 1;
    display: flex;
    flex-direction: row;
    gap: 6rem;
}

select {
    background-color: #000;
    border: 1px solid #888;
    border-radius: 6px;
    padding: 12px;
    color: white;
    font-size: 14px;
    outline: none;
}

.input-wrapper-description {
    display: flex;
    flex-direction: column;
    width: 350px;
    max-height: 350px;
    gap: 16px;
}

textarea {
    background-color: #000;
    border: 1px solid #888;
    border-radius: 6px;
    font-family: Arial, Helvetica, sans-serif;
    padding: 12px;
    color: white;
    font-size: 14px;
    outline: none;
}

.create-user-button{
    margin-top: 60px;
    background: #1CD66A;
    font-weight: bold;
    font-size: 14px;
    width: 300px;
    border: none;
    padding: 14px;
    border-radius: 24px;
    cursor: pointer;
    transition: background 0.3s;
}

.create-user-button:hover {
    background-color: #1db954;
}



`, "",{"version":3,"sources":["webpack://./src/styles/create_user.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,YAAY;IACZ,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".create-user-container {\n    background: #111111;\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 20px;\n}\n\n.create-user-form {\n    display: flex;\n    gap: 3rem;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    max-width: 350px;\n    margin-top: 30px;\n}\n\n.row {\n    flex: 1;\n    display: flex;\n    flex-direction: row;\n    gap: 6rem;\n}\n\nselect {\n    background-color: #000;\n    border: 1px solid #888;\n    border-radius: 6px;\n    padding: 12px;\n    color: white;\n    font-size: 14px;\n    outline: none;\n}\n\n.input-wrapper-description {\n    display: flex;\n    flex-direction: column;\n    width: 350px;\n    max-height: 350px;\n    gap: 16px;\n}\n\ntextarea {\n    background-color: #000;\n    border: 1px solid #888;\n    border-radius: 6px;\n    font-family: Arial, Helvetica, sans-serif;\n    padding: 12px;\n    color: white;\n    font-size: 14px;\n    outline: none;\n}\n\n.create-user-button{\n    margin-top: 60px;\n    background: #1CD66A;\n    font-weight: bold;\n    font-size: 14px;\n    width: 300px;\n    border: none;\n    padding: 14px;\n    border-radius: 24px;\n    cursor: pointer;\n    transition: background 0.3s;\n}\n\n.create-user-button:hover {\n    background-color: #1db954;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
